import { memoize } from '../utils';

export const getOrCreateNumberFormatter = memoize(
    function getOrCreateNumberFormatter(locale: string, opts?: Intl.NumberFormatOptions): Intl.NumberFormat {
        return new Intl.NumberFormat(locale, opts);
    },
    (locale, opts) => JSON.stringify({ locale, opts }),
);
